import React from "react";

const Cancellation_policy = () => {
  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-10 col-xl-8">
          {/* Page Header */}
          <div className="text-center mb-5">
            <h1 className="fw-bold text-dark mb-3">
              Cancellation & Refund Policy
            </h1>
            <p className="text-muted border-top border-bottom py-3 mx-auto" style={{maxWidth: '400px'}}>
               Transparent, fair, and customer-focused policy by MyFoodMyPrice
            </p>
          </div>

          {/* Introduction */}
              <div className="bg-info bg-opacity-10 border-start border-3 border-info px-4 py-3 rounded-end">
            <div className="mb-4 text-start">
              <h5 className="text-dark mb-2">MyFoodMyPrice is a product of Biryani Palayam.</h5>
              <p className="fs-6 text-dark mb-0">
                Click here to visit{" "}
                <a href="https://www.biryanipalayam.com/" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-primary fw-semibold border-bottom border-primary">
                  Biryani Palayam
                </a>
              </p>
            </div>
              <p >
              MyFoodMyPrice believes in helping its customers as far as
              possible and follows a transparent and fair cancellation policy.
            </p>
          </div>

          {/* Cancellation Policy */}
          <div className="card border-0 shadow-sm rounded-3 mb-5">
            <div className="card-header border-0 bg-white py-4">
              <h3 className="fw-bold mb-0 text-dark">
                Cancellation Policy
              </h3>
            </div>
            <div className="card-body p-4 pt-0">
              <div className="mb-4">
                <div className="d-flex align-items-start mb-3">
                  <div className="me-3 mt-1">
                    <div className="bg-success bg-opacity-10 text-success rounded-circle d-flex align-items-center justify-content-center" 
                         style={{width: '24px', height: '24px'}}>
                      <span className="fw-bold">✓</span>
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <p className="mb-0 text-dark">
                      Orders are eligible for full cancellation and refund only if
                      the cancellation request is made before{" "}
                      <span className="badge bg-success bg-opacity-25 text-dark border border-success border-opacity-25 px-3 py-2">
                        5:00 PM IST
                      </span>{" "}
                      on the day prior to the scheduled pickup date.
                    </p>
                  </div>
                </div>
                
                <div className="d-flex align-items-start">
                  <div className="me-3 mt-1">
                    <div className="bg-dark bg-opacity-10 text-dark rounded-circle d-flex align-items-center justify-content-center" 
                         style={{width: '24px', height: '24px'}}>
                      <span className="fw-bold">✗</span>
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <p className="mb-0 text-dark">
                      Cancellation requests received after{" "}
                      <span className="badge bg-dark bg-opacity-10 text-dark border px-3 py-2">
                        5:00 PM IST
                      </span>{" "}
                      on the day prior to pickup will not be accepted, and no refund will
                      be provided.
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="bg-info bg-opacity-10 border-start border-3 border-info px-4 py-3 rounded-end">
                <p className="mb-0 text-dark">
                  This policy is necessary as food preparation planning begins
                  after the cutoff time.
                </p>
              </div>
            </div>
          </div>

          {/* Quality Issues & Refunds */}
          <div className="card border-0 shadow-sm rounded-3 mb-5">
            <div className="card-header border-0 bg-white py-4">
              <h3 className="fw-bold mb-0 text-dark">
                Quality Issues & Refunds
              </h3>
            </div>
            <div className="card-body p-4 pt-0">
              <div className="d-flex align-items-start mb-3">
                <div className="me-3 mt-1">
                  <div className="bg-primary bg-opacity-10 text-primary rounded-circle d-flex align-items-center justify-content-center" 
                       style={{width: '24px', height: '24px'}}>
                    <span className="fw-bold">1</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    In case a customer establishes that the quality of the food
                    purchased is not satisfactory, a refund or replacement may be
                    considered.
                  </p>
                </div>
              </div>
              
              <div className="d-flex align-items-start mb-3">
                <div className="me-3 mt-1">
                  <div className="bg-primary bg-opacity-10 text-primary rounded-circle d-flex align-items-center justify-content-center" 
                       style={{width: '24px', height: '24px'}}>
                    <span className="fw-bold">2</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    Such issues must be reported to the customer service team
                    within{" "}
                    <span className="badge bg-warning bg-opacity-25 text-dark border border-warning border-opacity-25 px-3 py-2">
                      2 hours
                    </span>{" "}
                    of the pickup time.
                  </p>
                </div>
              </div>
              
              <div className="d-flex align-items-start">
                <div className="me-3 mt-1">
                  <div className="bg-primary bg-opacity-10 text-primary rounded-circle d-flex align-items-center justify-content-center" 
                       style={{width: '24px', height: '24px'}}>
                    <span className="fw-bold">3</span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 text-dark">
                    The customer service team will review the complaint and take
                    an appropriate decision. Validation of the claim will be done
                    independently by MyFoodMyPrice.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Refund Processing */}
          <div className="card border-0 shadow-sm rounded-3">
            <div className="card-header border-0 bg-white py-4">
              <h3 className="fw-bold mb-0 text-dark">
                Refund Processing
              </h3>
            </div>
            <div className="card-body p-4 pt-0">
              <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <p className="fs-5 mb-0 text-dark">
                    Any refund approved by MyFoodMyPrice will be processed within{" "}
                    <span className="badge bg-success bg-opacity-25 text-dark border border-success border-opacity-25 px-3 py-2 fw-bold">
                      1–2 working days
                    </span>{" "}
                    to the original mode of payment.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cancellation_policy; 